// extracted by mini-css-extract-plugin
module.exports = {"background":"XCCjXG5o","hero":"_1HyFFFSK","subtitle":"_11Iiq20U _1d0WKk0g _2KV5d31r _3mW2gstu","jobsContainer":"IBkntpor","hr":"_2ZF_6G07"};